"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaChoicesMapper = exports.mediaIdsMapper = exports.updateMediaItemMapper = void 0;
var mappers_1 = require("../products/mappers");
exports.updateMediaItemMapper = function (mediaItem) {
    var mediaSrc = mappers_1.getCreateOrderMediaSrc(mediaItem.src);
    return {
        mediaId: mediaSrc.id || mediaItem.mediaId,
        url: mediaSrc.externalImageUrl || mediaItem.url,
        choice: mediaItem.choice,
    };
};
exports.mediaIdsMapper = function (ids) {
    if (!ids) {
        return null;
    }
    return ids.map(function (item) {
        var src = mappers_1.getCreateOrderMediaSrc(item);
        return src.id ? src.id : src.externalImageUrl;
    });
};
exports.mediaChoicesMapper = function (item) {
    return {
        option: item.option,
        choice: item.choice,
        mediaIds: exports.mediaIdsMapper(item.mediaSources) || item.mediaIds,
    };
};
//# sourceMappingURL=media.mapper.js.map